import { React, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Table from "../../pagination/datatable";
import CommonFooter from "../../common/footer/commonFooter";
import TooltipIcons from "../../common/tooltip-content/tooltipIcons";
import RefreshIcon from "../../common/tooltip-content/refresh";
import CollapesIcon from "../../common/tooltip-content/collapes";
import Select from "react-select";
// import ImageWithBasePath from "../../img/imagewithbasebath";
import {
  createWarehouse,
  fetchWarehouses,
  updateWarehouse,
  deleteWarehouse,
} from "../../../api/warehouseApi";
import { toast } from "react-toastify";

const WareHouses = () => {
  const [warehouseNameEN, setWarehouseNameEN] = useState("");
  const [warehouseNameAR, setWarehouseNameAR] = useState("");
  const [contactPersonEN, setContactPersonEN] = useState("");
  const [contactPersonAR, setContactPersonAR] = useState("");
  const [phone, setPhone] = useState("");
  const [workPhone, setWorkPhone] = useState("");
  const [email, setEmail] = useState("");
  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");
  const [countryEN, setCountryEN] = useState("");
  const [countryAR, setCountryAR] = useState("");
  const [stateEN, setStateEN] = useState("");
  const [stateAR, setStateAR] = useState("");
  const [cityEN, setCityEN] = useState("");
  const [cityAR, setCityAR] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [warehouseData, setWarehouseData] = useState([]);
  const [selectedWarehouseId, setSelectedWarehouseId] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [warehouseToDelete, setWarehouseToDelete] = useState(null);

  const dataSource = warehouseData;

  const loadWarehouses = async () => {
    try {
      const data = await fetchWarehouses();
      setWarehouseData(data);
    } catch (err) {
      toast.error(`❌ ${window.translate("Failed to load warehouses")}`);
    }
  };

  useEffect(() => {
    loadWarehouses();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const missingFields = [
      warehouseNameEN,
      warehouseNameAR,
      contactPersonEN,
      contactPersonAR,
      countryEN,
      countryAR,
      stateEN,
      stateAR,
      cityEN,
      cityAR,
      phone,
      email,
      address1,
      zipCode,
    ];

    if (missingFields.some((field) => !field)) {
      toast.error(
        `❌ ${window.translate("Please fill all required fields.")}`
      );
      return;
    }

    const payload = {
      warehouseName: { en: warehouseNameEN, ar: warehouseNameAR },
      contactPerson: { en: contactPersonEN, ar: contactPersonAR },
      phone,
      workPhone,
      email,
      address1,
      address2,
      country: { en: countryEN, ar: countryAR },
      state: { en: stateEN, ar: stateAR },
      city: { en: cityEN, ar: cityAR },
      zipCode,
    };

    try {
      if (isEditMode && selectedWarehouseId) {
        await updateWarehouse(selectedWarehouseId, payload);
        // toast.success("✅ Warehouse updated successfully");
        toast.success(` ${window.translate("Warehouse updated successfully")}`)
        // Optional: refresh supplier list or close modal
        document.getElementById("close-add-stock-btn")?.click();

        // Reload after short delay
        setTimeout(() => {
          window.location.reload();
        }, 800);
      } else {
        await createWarehouse(payload);
        // toast.success("✅ Warehouse created successfully");
        toast.success(` ${window.translate("Warehouse created successfully")}`)
        // Optional: refresh supplier list or close modal
        document.getElementById("close-add-stock-btn")?.click();

        // Reload after short delay
        setTimeout(() => {
          window.location.reload();
        }, 800);
      }

      setIsEditMode(false);
      setSelectedWarehouseId(null);
      loadWarehouses(); // reload list
    } catch (err) {
      toast.error(err?.response?.data?.error || `❌ ${window.translate("Failed to save warehouse")}`);
    }
  };

  const handleDeleteWarehouse = async () => {
    if (!warehouseToDelete) return;

    try {
      await deleteWarehouse(warehouseToDelete);
      // toast.success("✅ Warehouse deleted successfully");
      toast.success(` ${window.translate("Warehouse deleted successfully")}`)
      setWarehouseToDelete(null);
      loadWarehouses(); // reload updated list
      // Optional: refresh supplier list or close modal
      document.getElementById("close-add-stock-btn")?.click();

      // Reload after short delay
      setTimeout(() => {
        window.location.reload();
      }, 800);
    } catch (err) {
      toast.error(
        err?.response?.data?.error || `❌ ${window.translate("Failed to delete warehouse")}`
      );
    }
  };

  const options1 = [
    { value: "choose", label: "Choose" },
    { value: "steven", label: "Steven" },
    { value: "gravely", label: "Gravely" },
  ];

  const options2 = [
    { value: "choose", label: "Choose" },
    { value: "uk", label: "United Kingdom" },
    { value: "us", label: "United States" },
  ];
  const columns = [
    {
      title: window.translate("Warehouse"),
      dataIndex: "warehouse",
      sorter: (a, b) => a.warehouse.length - b.warehouse.length,
    },
    {
      title: window.translate("Contact Person"),
      dataIndex: "contactPerson",
      render: (text) => (
        <div className="d-flex align-items-center">
          <Link to="#" className="avatar avatar-md">
            {/* <ImageWithBasePath
              src={`assets/img/warehouse/${data.img}`}
              className="img-fluid rounded-2"
              alt="img"
            /> */}
          </Link>
          <div className="ms-2">
            <p className="mb-0">
              <Link to="#" className="text-default">
                {text}
              </Link>
            </p>
          </div>
        </div>
      ),
      sorter: (a, b) => a.contactPerson.length - b.contactPerson.length,
    },

    {
      title: window.translate("Phone"),
      dataIndex: "phone",
      sorter: (a, b) => a.phone.length - b.phone.length,
    },

    // {
    //   title: window.translate("TotalProducts"),
    //   dataIndex: "totalProducts",
    //   sorter: (a, b) => a.totalProducts.length - b.totalProducts.length,
    // },
    {
      title: window.translate("TotalProducts"),
      dataIndex: "totalProducts",
      sorter: (a, b) => a.totalProducts - b.totalProducts,
    },
    {
      title: window.translate("Stock"),
      dataIndex: "stock",
      sorter: (a, b) => a.stock.length - b.stock.length,
    },
    {
      title: window.translate("Qty"),
      dataIndex: "qty",
      // sorter: (a, b) => a.qty.length - b.qty.length,
      sorter: (a, b) => a.qty - b.qty,
    },
    {
      title: window.translate("CreatedOn"),
      dataIndex: "createdOn",
      sorter: (a, b) => a.createdOn.length - b.createdOn.length,
    },
    {
      title: window.translate("Status"),
      dataIndex: "status",
      sorter: (a, b) => a.status.length - b.status.length,
      render: (text) => (
        <span
          className={`badge  d-inline-flex align-items-center badge-xs ${
            text === "Active" ? "badge-success" : "badge-danger"
          }`}
        >
          <i className="ti ti-point-filled me-1"></i>
          {text}
        </span>
      ),
    },

    {
      title: window.translate("Actions"),
      dataIndex: "actions",
      key: "actions",
      render: (_, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <Link
              className="me-2 p-2"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#add-units"
              onClick={() => {
                setIsEditMode(true);
                setSelectedWarehouseId(record.id);
                setWarehouseNameEN(record.warehouseName?.en || "");
                setWarehouseNameAR(record.warehouseName?.ar || "");
                setContactPersonEN(record.contactPersonFull?.en || "");
                setContactPersonAR(record.contactPersonFull?.ar || "");
                setPhone(record.phone || "");
                setWorkPhone(record.workPhone || "");
                setEmail(record.email || "");
                setAddress1(record.address1 || "");
                setAddress2(record.address2 || "");
                setCountryEN(record.country?.en || "");
                setCountryAR(record.country?.ar || "");
                setStateEN(record.state?.en || "");
                setStateAR(record.state?.ar || "");
                setCityEN(record.city?.en || "");
                setCityAR(record.city?.ar || "");
                setZipCode(record.zipCode || "");
              }}
            >
              <i data-feather="edit" className="feather-edit"></i>
            </Link>
            <Link
              className="confirm-text p-2"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#delete-modal"
              onClick={() => setWarehouseToDelete(record.id)}
            >
              <i data-feather="trash-2" className="feather-trash-2"></i>
            </Link>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>{window.translate("Warehouses")}</h4>
                <h6>{window.translate("Manage Your warehouses")}</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <TooltipIcons />
              <RefreshIcon />
              <CollapesIcon />
            </ul>
            <div className="page-btn">
              <Link
                to="#"
                className="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#add-units"
              >
                <i className="ti ti-circle-plus me-2 ms-2 ms-1"></i>
                {window.translate("Warehouses")}
              </Link>
            </div>
          </div>
          {/* /product list */}
          <div className="card table-list-card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="search-set"></div>
              <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="dropdown me-2">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white btn-md d-inline-flex align-items-center d-none"
                    data-bs-toggle="dropdown"
                  >
                    {window.translate("status")}
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        {window.translate("active")}
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        In{window.translate("active")}
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                {dataSource.length > 0 ? (
                  <Table columns={columns} dataSource={dataSource} />
                ) : (
                  <div className="text-center py-4">No warehouses found.</div>
                )}
              </div>
            </div>
          </div>
          {/* /product list */}
        </div>
        <CommonFooter />
      </div>
      <div>
        {/* Add Warehouse */}
        <div className="modal fade" id="add-units">
          <div className="modal-dialog modal-dialog-centered custom-modal-two">
            <div className="modal-content">
              <div className="page-wrapper-new p-0">
                <div className="content p-0">
                  <div className="modal-header border-0 custom-modal-header">
                    <div className="page-title">
                      {isEditMode ? `${window.translate("Edit Warehouse")}` : `${window.translate("Add Warehouse")}`}
                    </div>
                    <button
                      type="button"
                      className="close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">×</span>
                    </button>
                  </div>
                  <div className="modal-body custom-modal-body">
                    <form onSubmit={handleSubmit}>
                      <div className="modal-title-head">
                        <h6>
                          <span>
                            <i
                              data-feather="info"
                              className="feather-info me-2"
                            />
                          </span>
                          {window.translate("Warehouse Info")}
                        </h6>
                      </div>
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="mb-3">
                            <label className="form-label">{window.translate("Name")} (EN)</label>
                            <input
                              type="text"
                              className="form-control"
                              value={warehouseNameEN}
                              onChange={(e) =>
                                setWarehouseNameEN(e.target.value)
                              }
                            />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="mb-3">
                            <label className="form-label">{window.translate("Name")} (AR)</label>
                            <input
                              type="text"
                              className="form-control"
                              value={warehouseNameAR}
                              onChange={(e) =>
                                setWarehouseNameAR(e.target.value)
                              }
                            />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="input-blocks">
                            <label>{window.translate("Contact Person")} (EN)</label>
                            <input
                              type="text"
                              className="form-control"
                              value={contactPersonEN}
                              onChange={(e) =>
                                setContactPersonEN(e.target.value)
                              }
                            />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="input-blocks">
                            <label>{window.translate("Contact Person")} (AR)</label>
                            <input
                              type="text"
                              className="form-control"
                              value={contactPersonAR}
                              onChange={(e) =>
                                setContactPersonAR(e.target.value)
                              }
                            />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="mb-3 war-add">
                            <label className="mb-2">{window.translate("Phone Number")}</label>
                            <input
                              className="form-control"
                              name="phone"
                              type="text"
                              value={phone}
                              onChange={(e) => setPhone(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="mb-3">
                            <label className="form-label">{window.translate("Work Phone")}</label>
                            <input
                              type="text"
                              className="form-control"
                              value={workPhone}
                              onChange={(e) => setWorkPhone(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="mb-3">
                            <label className="form-label">{window.translate("Email")}</label>
                            <input
                              type="email"
                              className="form-control"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="modal-title-head">
                          <h6>
                            <span>
                              <i data-feather="map-pin" />
                            </span>
                            {window.translate("Location")}
                          </h6>
                        </div>
                        <div className="col-lg-12">
                          <div className="mb-3">
                            <label className="form-label">{window.translate("Address")} 1</label>
                            <input
                              type="text"
                              className="form-control"
                              value={address1}
                              onChange={(e) => setAddress1(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="mb-3">
                            <label className="form-label">{window.translate("Address")} 2</label>
                            <input
                              type="text"
                              className="form-control"
                              value={address2}
                              onChange={(e) => setAddress2(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="mb-3 mb-0">
                            <label className="form-label">{window.translate("City")} (EN)</label>
                            <input
                              type="text"
                              className="form-control"
                              value={cityEN}
                              onChange={(e) => setCityEN(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="mb-3 mb-0">
                            <label className="form-label">{window.translate("City")} (AR)</label>
                            <input
                              type="text"
                              className="form-control"
                              value={cityAR}
                              onChange={(e) => setCityAR(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="mb-3">
                            <label className="form-label">{window.translate("State")} (EN)</label>
                            <input
                              type="text"
                              className="form-control"
                              value={stateEN}
                              onChange={(e) => setStateEN(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="mb-3">
                            <label className="form-label">{window.translate("State")} (AR)</label>
                            <input
                              type="text"
                              className="form-control"
                              value={stateAR}
                              onChange={(e) => setStateAR(e.target.value)}
                            />
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="input-blocks">
                            <label>{window.translate("Country")} (EN)</label>
                            <input
                              type="text"
                              className="form-control"
                              value={countryEN}
                              onChange={(e) => setCountryEN(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="input-blocks">
                            <label>{window.translate("Country")} (AR)</label>
                            <input
                              type="text"
                              className="form-control"
                              value={countryAR}
                              onChange={(e) => setCountryAR(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="mb-3 mb-0">
                            <label className="form-label">{window.translate("Zipcode")} </label>
                            <input
                              type="text"
                              className="form-control"
                              value={zipCode}
                              onChange={(e) => setZipCode(e.target.value)}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="modal-footer-btn">
                        <button
                          type="submit"
                          className="btn btn-cancel me-2"
                          data-bs-dismiss="modal"
                        >
                          
                          {window.translate("Cancel")}
                        </button>
                        <button type="submit" className="btn btn-submit me-2">
                          {isEditMode ? `${window.translate("Save Changes")}` :`${window.translate("Create Warehouse")}` }
                          
                           {/* {window.translate("Create Warehouse")} */}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Add Warehouse */}
        {/* Edit Warehouse */}
        <div className="modal fade" id="edit-units">
          <div className="modal-dialog modal-dialog-centered custom-modal-two">
            <div className="modal-content">
              <div className="page-wrapper-new p-0">
                <div className="content p-0">
                  <div className="modal-header border-0 custom-modal-header">
                    <div className="page-title">
                      <h4>{window.translate("Edit Warehouse")}</h4>
                    </div>
                    <button
                      type="button"
                      className="close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">×</span>
                    </button>
                  </div>
                  <div className="modal-body custom-modal-body">
                    <form>
                      <div className="modal-title-head">
                        <h6>
                          <span>
                            <i
                              data-feather="info"
                              className="feather-info me-2"
                            />
                          </span>
                          {window.translate("Warehouse Info")}
                        </h6>
                      </div>
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="mb-3">
                            <label className="form-label">
                              {window.translate("name")}
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue="Legendary"
                            />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="input-blocks">
                            <label>{window.translate("Contact Person")}</label>
                            <Select
                              classNamePrefix="react-select"
                              options={options1}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="mb-3 war-edit-phone">
                            <label className="mb-2">{window.translate("Phone Number")}</label>
                            <input
                              className="form-control"
                              id="phone2"
                              name="phone"
                              type="text"
                            />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="mb-3 war-edit-phone">
                            <label className="form-label">{window.translate("Work Phone")}</label>
                            <input
                              className="form-control"
                              id="phone3"
                              name="phone"
                              type="text"
                            />
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="mb-3">
                            <label className="form-label">{window.translate("Email")}</label>
                            <input
                              type="email"
                              className="form-control"
                              defaultValue="stevenlegendary@example.com"
                            />
                          </div>
                        </div>
                        <div className="modal-title-head">
                          <h6>
                            <span>
                              <i data-feather="map-pin" />
                            </span>
                            {window.translate("Location")}
                          </h6>
                        </div>
                        <div className="col-lg-12">
                          <div className="mb-3">
                            <label className="form-label">{window.translate("Address")} 1</label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue="Admiral Street"
                            />
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="input-blocks">
                            <label className="form-label">{window.translate("Address")} 2</label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue="Aire Street"
                            />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="input-blocks">
                            <label>{window.translate("Country")}</label>
                            <Select
                              classNamePrefix="react-select"
                              options={options2}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="mb-3">
                            <label className="form-label">{window.translate("State")}</label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue="East England"
                            />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="mb-3 mb-0">
                            <label className="form-label">{window.translate("City")}</label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue="Leeds"
                            />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="mb-3 mb-0">
                            <label className="form-label">{window.translate("Zipcode")}</label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue="LS1"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="modal-footer-btn">
                        <button
                          type="button"
                          className="btn btn-cancel me-2"
                          data-bs-dismiss="modal"
                        >
                          {window.translate("cancel")}
                        </button>
                        <button type="submit" className="btn btn-submit me-2">
                          
                          {window.translate("Save Changes")}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal fade" id="delete-modal">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content p-5 px-3 text-center">
                <span className="rounded-circle d-inline-flex p-2 bg-danger-transparent mb-2">
                  <i className="ti ti-trash fs-24 text-danger" />
                </span>
                <h4 className="fs-20 text-gray-9 fw-bold mb-2 mt-1">
                  {window.translate("Delete")}
                </h4>
                <p className="text-gray-6 mb-0 fs-16">
                  {window.translate("Are you sure you want to delete product?")}
                </p>
                <div className="modal-footer-btn mt-3 d-flex justify-content-center">
                  <button
                    type="button"
                    className="btn me-2 btn-secondary fs-13 fw-medium p-2 px-3 shadow-none"
                    data-bs-dismiss="modal"
                  >
                    {window.translate("Cancel")}
                  </button>
                  <button
                    type="button"
                    data-bs-dismiss="modal"
                    className="btn btn-primary fs-13 fw-medium p-2 px-3"
                    onClick={handleDeleteWarehouse}
                  >
                    {window.translate("Yes Delete")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WareHouses;
